import NoteContext from "./noteContext";
import { useState } from "react";

const NoteState = (props) => {

    const host = process.env.REACT_APP_HOST;

    const notesInitial = [];
    const [notes, setNotes] = useState(notesInitial);


    // Get All Notes
    const getAllNotes = async () => {
        // API Call
        const response = await fetch(`${host}/api/notes/fetchallnotes`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'auth-token': localStorage.getItem('authToken')
            }
        });

        if(response.status!==200) {
            return false;
        }

        const json = await response.json();
        setNotes(json); 
        return true;
    }



    // Add a Note
    const addNote = async (title, description, tag) => {
        // API Call
        const response = await fetch(`${host}/api/notes/addnote`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'auth-token': localStorage.getItem('authToken')
            },
            body: JSON.stringify({title, description, tag})
        });

        if(response.status!==200) {
            return false;
        }

        const note = await response.json();
        setNotes(notes.concat(note));
        return true;
    }

    // Delete a Note
    const deleteNote = async (id) => {
        // API Call
        const response = await fetch(`${host}/api/notes/deletenote/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'auth-token': localStorage.getItem('authToken')
            }
        });

        if(response.status !== 200) {
            return false;
        }

        const newNotes = notes.filter((note) => { return note._id !== id });
        setNotes(newNotes);
        return true;
    }
    // Edit a Note
    const editNote = async (id, title, description, tag) => {
        // API Call
        const response = await fetch(`${host}/api/notes/updatenote/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'auth-token': localStorage.getItem('authToken')
            },
            body: JSON.stringify({title, description, tag})
        });

        if(response.status !== 200) {
            return false;
        }

        // Logic to edit Note on client side.
        let newNotes = JSON.parse(JSON.stringify(notes));
        for (let index = 0; index < newNotes.length; index++) {
            const element = newNotes[index];
            if (element._id === id) {
                newNotes[index].title = title;
                newNotes[index].description = description;
                newNotes[index].tag = tag;
                break;
            }
        }
        setNotes(newNotes);
        return true;
    }

    return (
        <NoteContext.Provider value={{ notes, addNote, deleteNote, editNote, getAllNotes }}>
            {props.children}
        </NoteContext.Provider>
    )
}

export default NoteState;